var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "log-item",
      class:
        "log-item-" +
        _vm.source.index +
        " " +
        (_vm.source.active ? "active" : ""),
      style: _vm.style
    },
    [
      _c("div", { staticClass: "line-no" }, [_vm._v(_vm._s(_vm.source.index))]),
      _c("div", { staticClass: "line-content" }, [
        _vm.isLogEnd
          ? _c("span", { staticStyle: { color: "#E6A23C" } }, [
              _c("span", { staticClass: "loading-text" }, [
                _vm._v(_vm._s(_vm.$t("Updating log...")))
              ]),
              _c("i", { staticClass: "el-icon-loading" })
            ])
          : _vm.source.isAnsi
          ? _c("span", { domProps: { innerHTML: _vm._s(_vm.dataHtml) } })
          : _c("span", { domProps: { innerHTML: _vm._s(_vm.dataHtml) } })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }